// Transient toast + the polite live-region for the critical-account count.

import { C } from '../lib/tokens';
import { useUi } from '../store/hooks';

export function Toasts() {
  const toast = useUi((s) => s.toast);
  const announce = useUi((s) => s.announce);
  return (
    <>
      {toast && (
        <div
          role="status"
          style={{
            position: 'fixed',
            right: 16,
            bottom: 16,
            zIndex: 80,
            background: '#111A2B',
            border: '1px solid rgba(76,158,232,.5)',
            borderRadius: 8,
            padding: '10px 14px',
            fontSize: 12,
            boxShadow: '0 12px 30px rgba(0,0,0,.45)',
            maxWidth: 380,
            color: C.tx,
          }}
        >
          {toast}
        </div>
      )}
      <div
        aria-live="polite"
        role="status"
        style={{ position: 'absolute', width: 1, height: 1, overflow: 'hidden', clip: 'rect(0 0 0 0)', whiteSpace: 'nowrap' }}
      >
        {announce}
      </div>
    </>
  );
}
